export const otherName = [
  { key: 'image', img: require('../image/photo.png') }
  // { key: 'video', img: require('../image/camera.png') }
]
